
import { RouteConfig } from 'vue-router';
import UnifiedInsightsReport from './unified-insights-reports.vue';

export const unifiedInsightsReportRoute: RouteConfig = { // tslint:disable-line:variable-name
  path: 'unified-reports',
  component: UnifiedInsightsReport,
};

export function getMyDefaultParams() {
  return {};
}
export default unifiedInsightsReportRoute;
